import { CanActivateFn, Router, UrlTree, createUrlTreeFromSnapshot } from '@angular/router';
import { OrderService } from '../../orders/order.service';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ToasterService } from '../../toaster/toaster.service';


export const isOrderEditableGuard: CanActivateFn = (route, state) => {
  const orderService = inject(OrderService);
  const toasterService = inject(ToasterService);
  const router = inject(Router);

  // Accessing the 'id' from the route parameters
  const orderId = route.paramMap.get('id');

  if (!orderId) {
    return of(router.createUrlTree(['/']));
  }

  return new Observable<boolean | UrlTree>((observer) => {
    orderService.getOrderEditableStatus(Number(orderId)).subscribe((isEditable) => {
      if (isEditable) {
        observer.next(true);
        observer.complete();
      } else {
        toasterService.showDanger("Order has been processed and cannot be edited")
        observer.next(createUrlTreeFromSnapshot(route, ['/']));
        observer.complete();
      }
    })
  });

};
